export const messages = {
  en: {
    adminSeckill: {
      queryCondition: 'Query Conditions',
      inputProductName: 'Please enter product name',
      query: 'Query',
      shopSeckill: 'Shop Seckill'
    },
    aShopDetailSeckill: {
      productName: 'Product Name',
      killHours: 'Seckill Hours', 
      continueHours: 'Duration Hours',
      totalCount: 'Purchase Within Validity',
      oneCount: 'Purchase Quantity Once',
      killPrice: 'Seckill Price',
      price: 'Single Price',
      killStock: 'Limit',
      state: 'Status',
      validity: 'Validity',
      open: 'Open',
      close: 'Close'
    }
  },
  zh: {
    adminSeckill: {
      queryCondition: '查询条件',
      inputProductName: '请输入商品名称',
      query: '查询',
      shopSeckill: '店铺秒杀'
    },
    aShopDetailSeckill: {
      productName: '产品名称',
      killHours: '秒杀小时',
      continueHours: '持续小时',
      totalCount: '有效期内购买',
      oneCount: '一次购买数量',
      killPrice: '秒杀金额',
      price: '单买金额',
      killStock: '限量',
      state: '状态',
      validity: '有效期',
      open: '开启',
      close: '关闭'
    }
  }
}